module.exports = __webpack_public_path__ + "static/media/section05_05.c56f01c5.jpg";